import styled from 'styled-components';

export const TextContainer = styled.div`
  display: none;
  background: white;
  font-size: 11pt;
  width: 600%;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
`;

export const Container = styled.div`
  width: 25px;
  height: 25px;
  margin: 5px;
  text-align: center;
  background-color: red;
  padding: 0%;
  border-radius: 30px;
  border: 1px solid white;
  &:hover ${TextContainer} {
    display: block;
  }
  &:hover {
    z-index: 1;
  }
`;

export const Mark = styled.div`
  font-weight: 400;
  color: white;
  margin-top: 11%;
`;
